var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 15,
    rx: 2,
    fill: "white",
    stroke: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1607_3491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.13664 6.01421V7.39234H5.67483C5.22576 7.43808 5.09576 7.46553 4.70386 7.56046C4.66954 7.56884 4.39926 7.64738 4.36647 7.65767C2.91248 8.12467 3.00245 8.96031 3.00055 9.1433C2.99902 9.30341 3.16676 10.2588 4.24677 10.2858C4.84414 10.2626 5.12549 9.90384 5.26044 9.67396C4.85559 9.89546 4.46903 9.63164 4.3577 9.4033C4.11334 8.90313 4.47513 8.39228 4.9467 8.09113C5.49604 7.73963 5.88831 7.7343 5.89213 7.7343V10.1589H7.27026V7.33973C7.27026 6.61235 6.68126 6.02184 5.9535 6.02031L3.13588 6.0146L3.13664 6.01421Z",
    fill: "#243BE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7445 6.0141V7.39222H18.2827C17.8336 7.43797 17.7036 7.46541 17.3117 7.56034C17.2774 7.56873 17.0071 7.64727 16.9743 7.65756C15.5204 8.12456 15.6103 8.9602 15.6088 9.14318C15.6073 9.3033 15.775 10.2586 16.855 10.2857C17.4525 10.2625 17.7337 9.90373 17.8687 9.67384C17.4642 9.89534 17.0773 9.63153 16.966 9.40318C16.7216 8.90301 17.0834 8.39217 17.5549 8.09101C18.1043 7.73951 18.4966 7.73418 18.5003 7.73418V10.1588H19.8785V7.33961C19.8785 6.61224 19.2895 6.02172 18.5617 6.0202L15.7442 6.01448L15.7445 6.0141Z",
    fill: "#ADF233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77324 6.41972C9.57042 6.69039 9.44729 7.10478 9.40421 7.66327H9.35808V6.0141H7.97729V10.1397H9.35808V8.46537C9.35808 7.81157 9.67755 7.37926 10.3169 7.37926H11.4411V6.0141H10.5933C10.249 6.0141 9.97567 6.14943 9.77285 6.41972",
    fill: "#243BE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0646 8.07424C13.0646 8.45776 13.3756 8.76883 13.7592 8.76883H15.1251V10.1481H13.7252C12.5987 10.1481 11.6853 9.23469 11.6853 8.10817V8.03993C11.6853 6.91341 12.5987 6 13.7252 6H15.1251V7.37927H13.7592C13.3756 7.37927 13.0646 7.69034 13.0646 8.07386",
    fill: "#243BE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1607_3491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 4.28571,
    fill: "white",
    transform: "translate(3 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.2dc048a4069837287491cfe5a55e6c12.svg";
export { ForwardRef as ReactComponent };